import { render, staticRenderFns } from "./VStart.vue?vue&type=template&id=575dbd24&"
import script from "./VStart.vue?vue&type=script&lang=js&"
export * from "./VStart.vue?vue&type=script&lang=js&"
import style0 from "./VStart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports